import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { Platform } from 'ionic-angular';

// ---- COMMON MODULES ---- //
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../providers/smart-audio';
import { ConnectivityService } from './connectivity-service';

/*
  Generated class for the Functions provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Functions {
  difficulty: string;
  language: string;
  level: number;
  numBg:number;
  showSidemenuButton:boolean=false;
  currentTextblock:any;
  currentDevice:any;
  serverurl: string;

  idCurrentBook:number;
  numBooksAvailable:number = 4;

  textblockForSingleSplicingForDB=[];

  emptyScore:number = 0;
  emptyLevel:number = 1;
  emptyCollectibles:any = {
    
  };
  emptyBooksinfo:any=[
    {
      book:1,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:423
    },{
      book:2,
      skip:3,
      bookmark:0,
      language:"en",
      numsnttotal:50
    },
    {
      book:3,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:104
    },{
      book:4,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:117
    },
    {
      book:5,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:192
    },{
      book:6,
      skip:3,
      bookmark:0,
      language:"en",
      numsnttotal:28
    },
    {
      book:7,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:92
    },{
      book:8,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:100
    },
    {
      book:9,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:100
    },{
      book:10,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:100
    },
    {
      book:11,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:100
    },{
      book:12,
      skip:3,
      bookmark:0,
      language:"it",
      numsnttotal:100
    }
  ];

  numSentenceToGuessInOneRound:number=5;

  bonusScore={
    easy: 2,
    normal: 4,
    hard: 6
  }

  constructor(public smartAudio: SmartAudio, private storage: Storage, public http: Http, public connectivityService: ConnectivityService, public translateService: TranslateService, public platform: Platform) {
    this.idCurrentBook=1;
    this.language='it';
    this.difficulty='normal';
    this.setDifficulty();
    this.setLanguage();
    this.changeShowSidemenuButtonTo(false);
    this.serverurl="http://xtribe.eu:3333/api/rubedo";
  }

  getCurrentDevice(){
    this.currentDevice=this.platform.platforms();
    return this.currentDevice;
  }

  getRandomGameBg(){
    this.numBg=this.randomIntBetween(1,6);
    return 'game_'+this.numBg+'_BgMusic';
  }

  initApp(){
    /* LOAD BG MUSICS */
    var tmpVol=this.smartAudio.getCurrentVolume();
    this.smartAudio.preloadComplex('app_BgMusic', 'assets/audio/bensound-buddy.mp3',tmpVol, 1, 0);

    this.smartAudio.preloadComplex('game_1_BgMusic', 'assets/audio/bensound-cute.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_2_BgMusic', 'assets/audio/bensound-clearday.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_3_BgMusic', 'assets/audio/bensound-jazzcomedy.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_4_BgMusic', 'assets/audio/bensound-littleidea.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_5_BgMusic', 'assets/audio/bensound-retrosoul.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_6_BgMusic', 'assets/audio/bensound-ukulele.mp3',tmpVol, 1, 0);

    this.smartAudio.preloadComplex('game_youLost', 'assets/audio/bensound-psychedelic.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_youWin', 'assets/audio/win.mp3',tmpVol, 1, 0);

    /* LOAD AUDIO EFFECTS */
    this.smartAudio.preloadSimple('cat_collar','assets/audio/cat-collar-jingle.mp3');
    this.smartAudio.preloadSimple('tick_tock','assets/audio/ticktock.mp3');
    this.smartAudio.preloadSimple('kitten_meow','assets/audio/kittenmeow.mp3');
    this.smartAudio.preloadSimple('sad_trombone','assets/audio/sad_trombone.mp3');
  }

  normalizeWordForComparison(word){
    // Normalized get rid of capital lettere and acute accents (substitute with grave)
    var normalizedWord=word;

    normalizedWord = normalizedWord.toLowerCase();
    normalizedWord = normalizedWord.replace(/é/gi, "è");
    normalizedWord = normalizedWord.replace(/á/gi, "à");
    normalizedWord = normalizedWord.replace(/í/gi, "ì");
    normalizedWord = normalizedWord.replace(/ó/gi, "ò");
    normalizedWord = normalizedWord.replace(/ú/gi, "ù");
   
    return normalizedWord;
  }

  play(musicName){
    this.smartAudio.play(musicName);
  }

  startBgMusic(musicName){
    this.smartAudio.startBgMusic(musicName);
  }

  stopBgMusic(musicName){
    this.smartAudio.stopBgMusic(musicName);
  }

  currentTimestamp(){
    return Date.now();
  };

  deviceIsOnline(){
    return this.connectivityService.isOnline();
  }
  //window.localStorage.setItem('myJsonKey', JSON.stringify(jsonObj));
  //var retrievedObj = JSON.parse(localStorage.getItem('myJsonKey'));

  convertStringDateForViz(date){
    date = date.split(' ')[0];
    var dateISO = new Date(date).toISOString();
    return dateISO;
  }

  randomIntBetween(min,max){
    return Math.floor(Math.random()*(max-min+1)+min);
  }

  getGameTimeAvailableAtCurrentDifficulty(){
    var timeAvailable=120;
    if(this.difficulty=="easy"){ timeAvailable=120; }
    if(this.difficulty=="normal"){ timeAvailable=100; }
    if(this.difficulty=="hard"){ timeAvailable=60; }
    
    return timeAvailable;
  }

  changeShowSidemenuButtonTo(value){
    this.showSidemenuButton=value;
  }

  setSideMenuColorEnabled(state){
    let elem: HTMLElement = document.getElementById('sideMenuButton');
    if(elem){
      if(!state){
        elem.setAttribute("style", "background-color:#ccc;");
      }else{
        elem.setAttribute("style", "background-color:#ef3b3b;");
      }
    }
  }

  splitInSentences(textblockToSplit){
    /*
    1) REGEXP splitting in sentences
    ([.?!]) = Capture either . or ? or ! as separators of sentences.
    \s* = Capture 0 or more whitespace characters following the previous token ([.?!]).
    (?=[A-Z]) = Optionally, the previous tokens only match if the next character is within the range A-Z (capital A to capital Z). Most English language sentences start with a capital letter.
    
    2) REPLACE
    "$1|" = We used one "capturing group" ([.?!]) and we capture one of those characters, and replace it with $1 (the match) plus |. So if we captured ? then the replacement would be ?|.
    
    3) SPLIT
    Finally, we split the pipes (|) and get our result.
    
    original regexp: /([.?!])\s*(?=[A-Z])/g
    */

    textblockToSplit=textblockToSplit.replace(/([.?!»…])»*\s*/g, "$1|").split("|");
    // Removing empty strings
    for (var i = 0; i < textblockToSplit.length; i++) { 
      if(textblockToSplit[i]==""){
        textblockToSplit.splice(i, 1);
      }
    }
    return textblockToSplit;
  }

  getArrayTextblocks(splitInSnt, bookmark, idCurrentBook){
    var textblocks=[];
    var numSnt=splitInSnt.length; // Sentences number
    var tmpSnt:string;
    var splitInWords: string[];
    var i:number;
    var lastWrdIndexSpace:number;
    var lastWrdIndex:number;
    var lastWrdIndexApo:number;
    var sntBeginning: string[];
    var sntLastWord: string[];
    var sntEnding: string[];
    var endingIndex:number;
    var ending:string;

    i=0;
    splitInWords=[];
    sntBeginning=[];
    sntLastWord=[];
    sntEnding=[];

    //console.log("splitInSnt: "+JSON.stringify(splitInSnt));
    for (i = 0; i < splitInSnt.length; i++) { 
      splitInWords=splitInSnt[i].split(/\b(?![\?\.\!])/);
      tmpSnt=splitInSnt[i];
      lastWrdIndexSpace = tmpSnt.lastIndexOf(" ");
      lastWrdIndexApo = tmpSnt.lastIndexOf("'");  
      if(lastWrdIndexSpace>=lastWrdIndexApo){
        lastWrdIndex=lastWrdIndexSpace+1;
      }else{
        lastWrdIndex=lastWrdIndexApo+1;
      }

      sntLastWord[i] = tmpSnt.substring(lastWrdIndex);
      sntBeginning[i] = tmpSnt.substring(0,lastWrdIndex);
      //console.log("BEGINNING: "+sntBeginning[i]);
        
      ending = sntLastWord[i].replace(/[^A-Za-zÀ-ÿ]/gi, ""); //remove any character that i not a letter (accented included)
      endingIndex=ending.length;
      ending = sntLastWord[i].substring(endingIndex);   
      sntLastWord[i] = sntLastWord[i].replace(/[^A-Za-zÀ-ÿ]/gi, "");
      //console.log("LAST WORD: "+sntLastWord[i]);  
      //console.log("ENDING: "+ending); 

      textblocks[i]={ 
        idBook: idCurrentBook,
        bookmarkTextblock:bookmark+i,
        wholeTextblock: splitInSnt[i],
        beginning:sntBeginning[i],
        lastWord:sntLastWord[i],
        ending:ending
      };      
    }
    return textblocks;
  }

  storeBooksDataOnDatabaseOnServer(){
    var i: number;
    i=1;

    this.http.get('assets/data/book_1.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,1);
      this.storeBooksDataOnServer();
    });

    this.http.get('assets/data/book_2.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,2);
      this.storeBooksDataOnServer();
    });

    this.http.get('assets/data/book_3.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,3);
      this.storeBooksDataOnServer();
    });

    this.http.get('assets/data/book_4.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,4);
      this.storeBooksDataOnServer();
    });

    this.http.get('assets/data/book_5.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,5);
      this.storeBooksDataOnServer();
    });

    this.http.get('assets/data/book_6.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,6);
      this.storeBooksDataOnServer();
    });
    
    this.http.get('assets/data/book_7.txt').subscribe(data=>{
      let obj = data['_body'];
      var splitInSntTotal=this.splitInSentences(obj);
      this.textblockForSingleSplicingForDB=this.getArrayTextblocks(splitInSntTotal,0,7);
      this.storeBooksDataOnServer();
    });
  }

  storeBooksDataOnServer(){
    console.log("storeBooksDataOnServer");
    return new Promise((resolve) =>{
      if(!this.deviceIsOnline()){
        //this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.textblockForSingleSplicingForDB; 
      
      /*console.log("textblockForSingleSplicingForDB is");
      console.log(this.textblockForSingleSplicingForDB);*/

      this.http.post(this.serverurl+"/storebooksdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeBooksDataOnServerIsOk");
        }, error => {
          console.log("error:"+error);// Error getting the data
          resolve(error);
          //this.setErrorMessage("storeBooksDataOnServer",error);
      });
    });
  }
  
  /* --------- GETTER/SETTER --------- */
  setDifficulty(){
     this.storage.set('difficulty', this.difficulty);
  }

  getDifficulty(){
    this.storage.get('difficulty').then((difficulty) => {
      this.difficulty=difficulty;
    });
  }

  showMessage(toastCtrl, message) {
    let toast = toastCtrl.create({
      message: message,
      position: 'middle',
      cssClass: 'toastMessage',
      duration: 3000
    });
    toast.present();
  }

  setLanguage(){
    if(this.language=='it' || this.language=='en' ){
     this.translateService.use(this.language)
    }
    this.storage.set('language', this.language);
  }

  getLanguage(){
    this.storage.get('language').then((language) => {
      this.language=language;
    });
  }
  /* --------- END --------- GETTER/SETTER --------- */
}



// WEBPACK FOOTER //
// ./src/providers/functions.ts